import React from 'react';
import {BubbleImageStyled} from "../../../styled/BubbleFloat";
import {useTheme} from "../Theme/ThemeContext";


const BubbleImage = ({img}) => {
    const {themeName} = useTheme();
    return (
        <BubbleImageStyled theme={themeName}>
            <img src={img} alt="buble image float"/>
        </BubbleImageStyled>
    )
}

export default BubbleImage;